"use strict";
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
Object.defineProperty(exports, "__esModule", { value: true });
exports.InsufficientPermissionError = void 0;
const teamsfx_api_1 = require("@microsoft/teamsfx-api");
const localizeUtils_1 = require("../../../../../common/localizeUtils");
const constants_1 = require("../utility/constants");
const errorCode = "InsufficientPermission";
const messageKey = "plugins.spfx.insufficientPermission";
class InsufficientPermissionError extends teamsfx_api_1.UserError {
    constructor(appCatalog) {
        super({
            source: constants_1.Constants.DeployDriverName,
            name: errorCode,
            message: (0, localizeUtils_1.getDefaultString)(messageKey, appCatalog, constants_1.Constants.DevProgramLink),
            displayMessage: (0, localizeUtils_1.getLocalizedString)(messageKey, appCatalog, constants_1.Constants.DevProgramLink),
        });
    }
}
exports.InsufficientPermissionError = InsufficientPermissionError;
//# sourceMappingURL=insufficientPermissionError.js.map